/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Section14FeeRenegotiation
 */
export interface Section14FeeRenegotiation {
    /**
     * 
     * @type {string}
     * @memberof Section14FeeRenegotiation
     */
    clientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof Section14FeeRenegotiation
     */
    clientLastName: string;
    /**
     * 
     * @type {Date}
     * @memberof Section14FeeRenegotiation
     */
    renegotiationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof Section14FeeRenegotiation
     */
    intermediaryFee: number;
    /**
     * 
     * @type {string}
     * @memberof Section14FeeRenegotiation
     */
    planName: string;
    /**
     * 
     * @type {string}
     * @memberof Section14FeeRenegotiation
     */
    planNumber: string;
    /**
     * 
     * @type {number}
     * @memberof Section14FeeRenegotiation
     */
    totalInvestmentValue: number;
}

/**
 * Check if a given object implements the Section14FeeRenegotiation interface.
 */
export function instanceOfSection14FeeRenegotiation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientFirstName" in value;
    isInstance = isInstance && "clientLastName" in value;
    isInstance = isInstance && "renegotiationDate" in value;
    isInstance = isInstance && "intermediaryFee" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "planNumber" in value;
    isInstance = isInstance && "totalInvestmentValue" in value;

    return isInstance;
}

export function Section14FeeRenegotiationFromJSON(json: any): Section14FeeRenegotiation {
    return Section14FeeRenegotiationFromJSONTyped(json, false);
}

export function Section14FeeRenegotiationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Section14FeeRenegotiation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientFirstName': json['ClientFirstName'],
        'clientLastName': json['ClientLastName'],
        'renegotiationDate': (new Date(json['RenegotiationDate'])),
        'intermediaryFee': json['IntermediaryFee'],
        'planName': json['PlanName'],
        'planNumber': json['PlanNumber'],
        'totalInvestmentValue': json['TotalInvestmentValue'],
    };
}

export function Section14FeeRenegotiationToJSON(value?: Section14FeeRenegotiation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientFirstName': value.clientFirstName,
        'ClientLastName': value.clientLastName,
        'RenegotiationDate': (value.renegotiationDate.toISOString()),
        'IntermediaryFee': value.intermediaryFee,
        'PlanName': value.planName,
        'PlanNumber': value.planNumber,
        'TotalInvestmentValue': value.totalInvestmentValue,
    };
}

